import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {PreparationConditionnementService} from "../../../../core/services/conditionnements/preparation-conditionnement.service";
import {UtilsService} from "../../../../core/utils/utils.service";
import {HELP_FOLDERS} from "../../../../core/constants";
import {DATAGRID_ROW_TYPES} from "../../../../core/services/technique/devextreme.service";

@Component({
  selector: 'yo-preparation-calcul-conditionnement-details',
  templateUrl: './preparation-calcul-conditionnement-details.component.html',
  styleUrls: ['./preparation-calcul-conditionnement-details.component.scss']
})
export class PreparationCalculConditionnementDetailsComponent implements OnInit, OnDestroy {

  flatResults: any[] = [];

  pathFile: string = HELP_FOLDERS.CONDITIONNEMENT + '/conditionnement-calcul-details';

  constructor(private pcSvc: PreparationConditionnementService,
              public utils: UtilsService) {

  }

  @Input() detailsByPoidsConditionnement: any;

  @Input() set idParentSelected(id: number) {
    if (id) {
      this.pcSvc.getChildrenResults(id)
        .subscribe(results => {
          this.flatResults = results.resultList;
        });
    }
  }

  onRowPreparedDetailsSommaires = ($event: any): void => {
    if ($event.rowType === DATAGRID_ROW_TYPES.DATA && $event.data?.headerGroup)
      $event.rowElement.style.fontWeight = 'bold';
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }

}
